import { GLOBAL } from 'saddlebag-browser';
import URI from 'urijs';

import replaceUrlSearch from './replaceUrlSearch';

type UrlSearchParameters = Record<string, unknown>;

const updateUrlSearch = (updatedParams?: UrlSearchParameters): void => {
  if (!updatedParams || Object.keys(updatedParams).length === 0) {
    return;
  }

  const window = GLOBAL.getWindow();
  const { search } = window.location;
  const uri = new URI(search);
  const updatedSearch = uri.setSearch(updatedParams);

  replaceUrlSearch(`?${updatedSearch.query()}`);
};

export default updateUrlSearch;
